(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("Crunker", [], factory);
	else if(typeof exports === 'object')
		exports["Crunker"] = factory();
	else
		root["Crunker"] = factory();
})(self, function() {
return 